var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:information-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 2.5C21.9037 2.5 27.5 8.09625 27.5 15C27.5 21.9037 21.9037 27.5 15 27.5C8.09625 27.5 2.5 21.9037 2.5 15C2.5 8.09625 8.09625 2.5 15 2.5ZM14.9875 12.5H13.75C13.4314 12.5004 13.125 12.6223 12.8933 12.8411C12.6616 13.0598 12.5222 13.3587 12.5035 13.6767C12.4849 13.9948 12.5883 14.308 12.7928 14.5523C12.9973 14.7966 13.2874 14.9536 13.6038 14.9913L13.75 15V21.2375C13.75 21.8875 14.2425 22.425 14.875 22.4925L15.0125 22.5H15.625C15.8879 22.5 16.1441 22.4171 16.3572 22.2631C16.5702 22.1092 16.7294 21.8919 16.8119 21.6423C16.8944 21.3927 16.8961 21.1234 16.8168 20.8728C16.7374 20.6222 16.5811 20.4029 16.37 20.2463L16.25 20.1675V13.7625C16.25 13.1125 15.7575 12.575 15.125 12.5075L14.9875 12.5ZM15 8.75C14.6685 8.75 14.3505 8.8817 14.1161 9.11612C13.8817 9.35054 13.75 9.66848 13.75 10C13.75 10.3315 13.8817 10.6495 14.1161 10.8839C14.3505 11.1183 14.6685 11.25 15 11.25C15.3315 11.25 15.6495 11.1183 15.8839 10.8839C16.1183 10.6495 16.25 10.3315 16.25 10C16.25 9.66848 16.1183 9.35054 15.8839 9.11612C15.6495 8.8817 15.3315 8.75 15 8.75Z",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.c3fad5da4ad74493f79c9a4724b2f448.svg";
export { ForwardRef as ReactComponent };